import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  AUDIT_PURCHASE_ORDER_LIST,
  AUDIT_PURCHASE_ORDER,
  AUDIT_IGP_LIST_DATA,
  AUDIT_IGP_ROW_DATA,
  AUDIT_QUOTATION_ROW_DATA,
  AUDIT_RFQ_ROW_DATA,
  AUDIT_PI_ROW_DATA,
  AUDIT_MR_ROW_DATA,
  ITEM_AUDIT_APPROVAL,
} from "./actionTypes";
import {
  apiError,
  AuditPurchaseOrderListSuccessful,
  AuditPORowDataSuccessful,
  AuditIGPListDataSuccessful,
  AuditIGPRowDataSuccessful,
  AuditQRowDataSuccessful,
  AuditRFQRowDataSuccessful,
  AuditPIRowDataSuccessful,
  AuditMRRowDataSuccessful,
  AuditPO,
} from "./actions";
import swal from "sweetalert";

import {
  postAdd,
  getList,
  getParamsList,
  // getDownloadFile,
  // postEdit,
  // postDelete,
  // getRowData,
} from "../../helpers/Helper";

function* auditPurchaseOrderList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/purchaseorder/list", params);

    yield put(AuditPurchaseOrderListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditPurchaseOrderRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(getList, "/purchaseorder/" + ScreenID, {});
    yield put(AuditPORowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditIGPListData({ payload: { ScreenID } }) {
  try {
    const response = yield call(
      getList,
      "/goodsreceivednote2/goodsreceivednote2sbypo/" + ScreenID,
      {}
    );
    yield put(AuditIGPListDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditIGPRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(getList, "/goodsreceivednote2/" + ScreenID, {});
    yield put(AuditIGPRowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditQuotationRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(getList, "/quotation/" + ScreenID, {});
    yield put(AuditQRowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditRFQRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(
      getList,
      "/requestforquotation/" + ScreenID,
      {}
    );
    yield put(AuditRFQRowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditPIRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(getList, "/purchaseindent/" + ScreenID, {});
    yield put(AuditPIRowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* auditMRRowData({ payload: { ScreenID } }) {
  try {
    const response = yield call(getList, "/materialrequest/" + ScreenID, {});
    yield put(AuditMRRowDataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* ItemAuditApproval({ payload: { data } }) {
  try {
    const response = yield call(postAdd, "/purchaseorder/poiaudit", data);

    if (response.status === 201) {
      if (data.poauditstatus === 3)
        swal(" Your PO Item has been Audit sucessfully!", {
          icon: "success",
        });
      else if (data.poauditstatus === 4) {
        swal(" Your PO Item has been Audit Pending!", {
          icon: "success",
        });
      }

      yield put(
        AuditPO({
          ScreenID: data.purchaseorder_id,
        })
      );
    } else {
      if (data.poauditstatus === 3)
        swal(" Sorry! Your PO Item has been not audited!", {
          icon: "success",
        });
      else if (data.poauditstatus === 4) {
        swal(" Sorry! Your PO Item has been not Rejected!", {
          icon: "success",
        });
      }
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}
export function* watchAuditPurchaseOrderList() {
  yield takeEvery(AUDIT_PURCHASE_ORDER_LIST, auditPurchaseOrderList);
}
export function* watchAuditPurchaseOrderRowData() {
  yield takeEvery(AUDIT_PURCHASE_ORDER, auditPurchaseOrderRowData);
}
export function* watchAuditIGPListData() {
  yield takeEvery(AUDIT_IGP_LIST_DATA, auditIGPListData);
}
export function* watchAuditIGPRowData() {
  yield takeEvery(AUDIT_IGP_ROW_DATA, auditIGPRowData);
}
export function* watchAuditQuotationRowData() {
  yield takeEvery(AUDIT_QUOTATION_ROW_DATA, auditQuotationRowData);
}
export function* watchAuditRFQRowData() {
  yield takeEvery(AUDIT_RFQ_ROW_DATA, auditRFQRowData);
}
export function* watchAuditPIRowData() {
  yield takeEvery(AUDIT_PI_ROW_DATA, auditPIRowData);
}
export function* watchAuditMRRowData() {
  yield takeEvery(AUDIT_MR_ROW_DATA, auditMRRowData);
}
export function* watchItemAuditApproval() {
  yield takeEvery(ITEM_AUDIT_APPROVAL, ItemAuditApproval);
}
function* AuditReportSaga() {
  yield all([fork(watchAuditPurchaseOrderList)]);
  yield all([fork(watchAuditPurchaseOrderRowData)]);
  yield all([fork(watchAuditIGPListData)]);
  yield all([fork(watchAuditIGPRowData)]);
  yield all([fork(watchAuditQuotationRowData)]);
  yield all([fork(watchAuditRFQRowData)]);
  yield all([fork(watchAuditPIRowData)]);
  yield all([fork(watchAuditMRRowData)]);
  yield all([fork(watchItemAuditApproval)]);
}

export default AuditReportSaga;
